import { render, staticRenderFns } from "./fs-switch.vue?vue&type=template&id=56b4543f&scoped=true"
import script from "./fs-switch.vue?vue&type=script&lang=js"
export * from "./fs-switch.vue?vue&type=script&lang=js"
import style0 from "./fs-switch.vue?vue&type=style&index=0&id=56b4543f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b4543f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b4543f')) {
      api.createRecord('56b4543f', component.options)
    } else {
      api.reload('56b4543f', component.options)
    }
    module.hot.accept("./fs-switch.vue?vue&type=template&id=56b4543f&scoped=true", function () {
      api.rerender('56b4543f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/form-elements/fs-switch.vue"
export default component.exports